import React from 'react';

import {ThemeProvider} from '@gravity-ui/uikit';
import {Provider} from 'react-redux';
import ErrorBoundary from 'ui/components/ErrorBoundary';
import store, {selectors, useAppSelector} from 'ui/store';

const {selectTheme} = selectors;

const {lang} = window.YC;

const withTheme = <P extends {}>(Component: React.FC<P>) =>
    function WithThemeProvider(props: P) {
        const theme = useAppSelector(selectTheme);

        return (
            <ThemeProvider theme={theme} direction={['ar', 'he'].includes(lang) ? 'rtl' : 'ltr'}>
                <Component {...props} />
            </ThemeProvider>
        );
    };

export const withErrorBoundary = <P extends {}>(Component: React.FC<P>) =>
    function WithErrorBoundaryProvider(props: P) {
        return (
            <ErrorBoundary>
                <Component {...props} />
            </ErrorBoundary>
        );
    };

const withRedux = <P extends {}>(Component: React.FC<P>) =>
    function WithReduxProvider(props: P) {
        return (
            <Provider store={store}>
                <Component {...props} />
            </Provider>
        );
    };

export const withAppProviders = <Props extends object>(Component: React.FC<Props>) => {
    return withErrorBoundary(withRedux(withTheme(Component)));
};
